import React from 'react'
import { Row, Col } from 'reactstrap'
import { Event as EventCard } from '../EventsCard'
const Upcoming = ({
    newAllEvents,
    setSelectedEvent,
    toggleShowEventDetails
}) => {
    return (
        <div>
            <Row className='g-4'>
                {newAllEvents.slice(0, 4)?.map(el => (
                    <Col sm='12' md='6' lg='3'>
                        <EventCard
                            event={el}
                            setSelectedEvent={setSelectedEvent}
                            toggleShowEventDetails={toggleShowEventDetails}
                        />
                    </Col>
                ))}
            </Row>
        </div>
    )
}

export default Upcoming